import type { TrendDirection } from './trend-icon.constant';

export const TREND_ICON_TEXT: Record<TrendDirection, string> = {
  up: '상승',
  down: '하락',
  flat: '변동 없음',
};
